import type { TabSection } from './eto-app';

function EtoTabs({ componentName, sectionTabs, setSectionTabs, activeSection, setActiveSection, i18n }: {
    componentName: string;
    sectionTabs: TabSection[];
    setSectionTabs: (sectionTabs: TabSection[]) => void;
    activeSection: string;
    setActiveSection: (section: string) => void;
    i18n: (key: string) => string;
}) {
    return (sectionTabs.filter((tab) => (!tab.hidden && (tab.subtabs.length === 0 || tab.subtabs.some((subtab) => !subtab.hidden)))).map((tab) => {
        const tabTarget = tab.subtabs.length > 0 ? tab.name + '__' + tab.subtabs[0].name : tab.name;
        return (
            <>
                <div
                    role="tab"
                    tabIndex={0}
                    aria-selected={activeSection.startsWith(tab.name)}
                    className={`${componentName}__section-tab ${activeSection.startsWith(tab.name) ? 'active' : ''}`}
                    onClick={() => {
                        if (activeSection.startsWith(tab.name)) {
                            setSectionTabs(sectionTabs.map((sectionTab) => {
                                if (sectionTab.name === tab.name) {
                                    return { ...sectionTab, collapseSubtabs: !sectionTab.collapseSubtabs };
                                }
                                return sectionTab;
                            }));
                        } else {
                            setSectionTabs(sectionTabs.map((sectionTab) => {
                                if (sectionTab.name === tab.name) {
                                    return { ...sectionTab, collapseSubtabs: false };
                                }
                                return sectionTab;
                            }));
                            setActiveSection(tabTarget);
                        }
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            setActiveSection(tabTarget);
                        }
                    }}
                >{i18n(tab.label)}</div>
                {activeSection.startsWith(tab.name) && tab.subtabs.length > 0 && !tab.collapseSubtabs && tab.subtabs.map((subtab) => (
                    <div
                        role="tab"
                        tabIndex={0}
                        aria-selected={activeSection === tab.name + '__' + subtab.name}
                        className={`${componentName}__section-tab ${componentName}__section-tab-subtab ${activeSection === tab.name + '__' + subtab.name ? 'active' : ''}`}
                        onClick={() => setActiveSection(tab.name + '__' + subtab.name)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                setActiveSection(tab.name + '__' + subtab.name);
                            }
                        }}
                    >{i18n(subtab.label)}</div>
                ))}
            </>
        );
    }));
}

export default EtoTabs;